import { createFileRoute } from "@tanstack/react-router"

import { MembershipsRouteComponent } from "@/routes/_authenticated/account/memberships/index"
import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/memberships/"
)({
  staticData: {
    pageName: "Keys & Memberships",
  },
  loader: () => ({
    crumb: { translationKey: "common:keysAndMemberships.header" } as Crumb,
  }),
  component: MembershipsRouteComponent,
})
